import { IHitPaywallSendLeadsParams } from '@patsnap/synapse_common_interface'
import { sharedCtx } from '../../context'

export type ISendHitPaywallLeadsOptions = {
  userId?: string
  applyPlan?: string
  triggerPoint?: string
}

export function sendHitPaywallLeads(options: ISendHitPaywallLeadsOptions = {}) {
  const searchParams = new URLSearchParams(window.location.search)
  const fromPage = searchParams.get('from_page') || window.location.href
  const fromPageUrl = searchParams.get('from_page_url') || window.location.href
  const params: IHitPaywallSendLeadsParams = {
    type: 'hit_paywall',
    product: 'synapse',
    device_type: 'PC',
    launch_pad: [fromPage, options.triggerPoint].filter(Boolean).join('/'),
    page_url: fromPageUrl,
    apply_plan: options.applyPlan,
    user_id: options.userId,
  }

  return sharedCtx.service.login.sendLeads(params).catch(() => undefined)
}
